//  the process key/value pair specifies which document can be used in which process
// process: ["renewal", "newreg", "changeowner", "drivlicense"],
const { vehicleProcess } = require("../../constants")
const customizedNumberPlate = require("../multi-city/customized-number-plate")
const {
  comprehensiveInsuranceDocs,
} = require("../multi-city/comprehensive-insurance")
const { vehicleTrackingDocs } = require("../multi-city/vehicle-tracking")

const { RENEWAL, NEW_REG, CHANGE_OWNER, ESTIMATE } = vehicleProcess

const lgDocs = [
  { desc: "Local govt paper", docs: { sw: 4500, ng: 10500 } },
  { desc: "JTB - Joint Tax Board", docs: { sw: 9000, ng: 9000 } },
  { desc: "National Unified ByPass (NUBS)", docs: { sw: 3500, ng: 3500 } },
  { desc: "Urban access", docs: { sw: 0, ng: 4500 } },
  { desc: "Drive way permit", docs: { sw: 2500, ng: 2500 } },
  { desc: "Environmental Devt.Levy (EDL) Light", docs: { sw: 4500, ng: 4500 } },
  { desc: "Daily toll", docs: { sw: 9000, ng: 9000 } },
  { desc: "Basket or Stickers", docs: { sw: 3500, ng: 3500 } },
  { desc: "Heavy and Light Duty", docs: { sw: 2500, ng: 2500 } },
]
const totalLg = (region) => {
  return lgDocs.reduce(
    (total, doc) => {
      total.cost += doc.docs[region]
      total.desc += `, ${doc.desc}`
      return total
    },
    { desc: "Covers for", cost: 0 },
  )
}
const LG_NG = totalLg("ng")

const docs = (typeOfDoc = "private", typeOfPlate = "regular") => [
  {
    key: "vl",
    name: "Vehicle Licence",
    description: "Required for every vehicle",
    connected:
      typeOfDoc === "private"
        ? ["rw", "vreg", "poc"]
        : ["rw", "vreg", "poc", "hp"],
    process: [RENEWAL, NEW_REG, CHANGE_OWNER, ESTIMATE],
    processingTime: 1,
    price: [
      { cost: 0, price: 0 },
      { cost: 1500, price: 2500 }, // +1000
      { cost: 4000, price: 5000 },
      { cost: 4000, price: 5000 },
      { cost: 4200, price: 5200 },
      { cost: 6600, price: 7600 },
      { cost: 27000, price: 28000 }, // +1000
      { cost: 27000, price: 28000 },
      { cost: 27000, price: 28000 },
    ],
    meta: {},
  },
  {
    key: "rw",
    name: "Road Worthiness",
    description: "Required for every vehicle",
    connected:
      typeOfDoc === "private"
        ? ["vl", "vreg", "poc"]
        : ["vl", "hp", "vreg", "poc"],
    process: [RENEWAL, NEW_REG, CHANGE_OWNER, ESTIMATE],
    processingTime: 2,
    price:
      typeOfDoc === "private"
        ? [
            { cost: 0, price: 0 },
            { cost: 3000, price: 4200 }, // +1200
            { cost: 5500, price: 6700 },
            { cost: 6300, price: 7500 },
            { cost: 6300, price: 7500 },
            { cost: 9000, price: 10200 },
            { cost: 11000, price: 12200 },
            { cost: 11000, price: 12200 },
            { cost: 11500, price: 12700 },
          ]
        : [
            { cost: 0, price: 0 },
            { cost: 2500, price: 3700 }, // +1200
            { cost: 5000, price: 6200 },
            { cost: 5800, price: 7000 },
            { cost: 5800, price: 7000 },
            { cost: 8500, price: 9700 },
            { cost: 10500, price: 11700 },
            { cost: 10500, price: 11700 },
            { cost: 11000, price: 12200 },
          ],
    meta: {},
  },
  {
    key: "ins",
    name: "Third Party Insurance",
    description:
      "Either a third-party or comprehensive insurance is required for vehicles",
    connected: [],
    process: [RENEWAL, NEW_REG, CHANGE_OWNER, ESTIMATE],
    processingTime: 1,
    price:
      typeOfDoc === "private"
        ? [
            { cost: 0, price: 0 },
            { cost: 4000, price: 5000 },
            { cost: 13000, price: 15000 },
            { cost: 13000, price: 15000 },
            { cost: 1300, price: 15000 },
            { cost: 17000, price: 20000 },
            { cost: 80000, price: 100000 },
            { cost: 80000, price: 100000 },
            { cost: 80000, price: 100000 },
          ]
        : [
            { cost: 0, price: 0 },
            { cost: 4000, price: 5000 },
            { cost: 17000, price: 20000 },
            { cost: 17000, price: 20000 },
            { cost: 17000, price: 20000 },
            { cost: 17000, price: 20000 },
            { cost: 80000, price: 100000 },
            { cost: 80000, price: 100000 },
            { cost: 80000, price: 100000 },
          ],
    meta: {},
  },
  {
    ...comprehensiveInsuranceDocs,
  },
  {
    key: "hp",
    name: "Hackney Permit",
    description: "Required for commercial vehicles",
    connected: [],
    process: [RENEWAL, NEW_REG, CHANGE_OWNER, ESTIMATE],
    processingTime: 1,
    price: [
      { cost: 0, price: 0 },
      { cost: 2500, price: 3500 }, // +1000
      { cost: 4100, price: 5100 },
      { cost: 4100, price: 5100 },
      { cost: 4800, price: 5800 },
      { cost: 4800, price: 5800 },
      { cost: 6600, price: 7600 },
      { cost: 6600, price: 7600 },
      { cost: 6600, price: 7600 },
    ],
    meta: {},
  },
  {
    key: "poc",
    name: "Proof of Ownership Certificate",
    description: "Required for all vehicles",
    connected: [],
    process: [RENEWAL, NEW_REG, CHANGE_OWNER, ESTIMATE],
    processingTime: 1,
    price: [
      { cost: 0, price: 0 },
      { cost: 1000, price: 2500 }, // +1500
      { cost: 1000, price: 2500 },
      { cost: 1000, price: 2500 },
      { cost: 1000, price: 2500 },
      { cost: 1000, price: 2500 },
      { cost: 1000, price: 2500 },
      { cost: 1000, price: 2500 },
      { cost: 1000, price: 2500 },
    ],
    meta: {
      disabled: true,
    },
  },
  {
    key: "cmr",
    name: "Central Motor Registry (CMR)",
    description: "Required for all vehicles",
    connected: [],
    process: [RENEWAL, NEW_REG, CHANGE_OWNER, ESTIMATE],
    processingTime: 3,
    price: [
      { cost: 0, price: 0 },
      { cost: 5700, price: 7200 }, // +1500
      { cost: 5700, price: 7200 },
      { cost: 5700, price: 7200 },
      { cost: 5700, price: 7200 },
      { cost: 5700, price: 7200 },
      { cost: 5700, price: 7200 },
      { cost: 5700, price: 7200 },
      { cost: 5700, price: 7200 },
    ],
    meta: {},
  },
  {
    key: "vreg",
    name: "Vehicle Registry (VREG)",
    description: "Required for all vehicles",
    connected: [],
    process: [RENEWAL, NEW_REG, CHANGE_OWNER, ESTIMATE],
    processingTime: 1,
    price: [
      { cost: 0, price: 0 },
      { cost: 2500, price: 3500 }, // +1000
      { cost: 2500, price: 3500 },
      { cost: 2500, price: 3500 },
      { cost: 2500, price: 3500 },
      { cost: 2500, price: 3500 },
      { cost: 2500, price: 3500 },
      { cost: 2500, price: 3500 },
      { cost: 2500, price: 3500 },
    ],
    meta: {
      notDelivered: true,
    },
  },
  {
    key: "npr",
    name:
      typeOfPlate === "regular" || typeOfPlate === "regular-custom-lg"
        ? "Number Plate Reprint"
        : "Number Plate Reprint (Customized)",
    description: "Optional, can be ordered on-demand",
    connected: [],
    process: [RENEWAL, ESTIMATE],
    processingTime: 180,
    price:
      typeOfPlate === "regular" || typeOfPlate === "regular-custom-lg"
        ? [
            { cost: 0, price: 0 },
            { cost: 43000, price: 52000 },
            { cost: 43000, price: 52000 },
            { cost: 43000, price: 52000 },
            { cost: 43000, price: 52000 },
            { cost: 43000, price: 52000 },
            { cost: 100000, price: 115000 },
            { cost: 100000, price: 115000 },
            { cost: 100000, price: 115000 },
          ]
        : customizedNumberPlate,
    meta: {},
  },
  {
    key: "lg",
    name: "L/Govt. Permit (Nigeria)",
    description: LG_NG.desc,
    connected: [],
    process: [RENEWAL, NEW_REG, CHANGE_OWNER, ESTIMATE],
    processingTime: 3,
    price: [
      { cost: 0, price: 0 },
      { cost: LG_NG.cost, price: LG_NG.cost + 5500 },
      { cost: LG_NG.cost, price: LG_NG.cost + 5500 },
      { cost: LG_NG.cost, price: LG_NG.cost + 5500 },
      { cost: LG_NG.cost, price: LG_NG.cost + 5500 },
      { cost: LG_NG.cost, price: LG_NG.cost + 5500 },
      { cost: LG_NG.cost, price: LG_NG.cost + 5500 },
      { cost: LG_NG.cost, price: LG_NG.cost + 5500 },
      { cost: LG_NG.cost, price: LG_NG.cost + 5500 },
    ],
    meta: {},
  },
  {
    key: "sc",
    name: "State Carriage Permit",
    description: "Required for commercial vehicles",
    connected: [],
    process: [RENEWAL, NEW_REG, CHANGE_OWNER, ESTIMATE],
    processingTime: 1,
    price: [
      { cost: 0, price: 0 },
      { cost: 6000, price: 7000 }, // +1000
      { cost: 7500, price: 8500 },
      { cost: 7500, price: 8500 },
      { cost: 7500, price: 8500 },
      { cost: 7500, price: 8500 },
      { cost: 7500, price: 8500 },
      { cost: 7500, price: 8500 },
      { cost: 7500, price: 8500 },
    ],
    meta: {},
  },
  {
    key: "hvp",
    name: "Heavy Duty Permit",
    description: "Required for trucks & pickups",
    connected: [],
    process: [RENEWAL, NEW_REG, CHANGE_OWNER, ESTIMATE],
    processingTime: 1,
    price: [
      { cost: 0, price: 0 },
      { cost: 0, price: 0 },
      { cost: 7500, price: 9500 }, // +2000
      { cost: 7500, price: 9500 },
      { cost: 7500, price: 9500 },
      { cost: 7500, price: 9500 },
      { cost: 11500, price: 13500 },
      { cost: 11500, price: 13500 },
      { cost: 11500, price: 13500 },
    ],
    meta: {},
  },
  {
    key: "ttp",
    name: "Trailer & Tipper Permit (TTP)",
    description: "Required for trucks",
    connected: [],
    process: [RENEWAL, NEW_REG, CHANGE_OWNER, ESTIMATE],
    processingTime: 2,
    price: [
      { cost: 0, price: 0 },
      { cost: 0, price: 0 },
      { cost: 0, price: 0 },
      { cost: 0, price: 0 },
      { cost: 0, price: 0 },
      { cost: 5000, price: 6500 }, // +1500
      { cost: 5000, price: 6500 },
      { cost: 5000, price: 6500 },
      { cost: 5000, price: 6500 },
    ],
    meta: {},
  },
  {
    key: "myp",
    name: "Mid Year Permit",
    description: "Required for commercial vehicles every mid year",
    connected: [],
    process: [RENEWAL, NEW_REG, CHANGE_OWNER, ESTIMATE],
    processingTime: 2,
    price: [
      { cost: 0, price: 0 },
      { cost: 2000, price: 4000 }, // + 2000
      { cost: 2000, price: 4000 },
      { cost: 2000, price: 4000 },
      { cost: 2000, price: 4000 },
      { cost: 2000, price: 4000 },
      { cost: 2000, price: 4000 },
      { cost: 2000, price: 4000 },
      { cost: 2000, price: 4000 },
    ],
    meta: {},
  },
  {
    key: "nubs",
    name: "National Unified ByPass (NUBS)",
    description: "Required for commercial vehicles",
    connected: [],
    process: [RENEWAL, NEW_REG, CHANGE_OWNER, ESTIMATE],
    processingTime: 2,
    price: [
      { cost: 0, price: 0 },
      { cost: 2500, price: 4000 }, // + 1500
      { cost: 2500, price: 4000 },
      { cost: 2500, price: 4000 },
      { cost: 2500, price: 4000 },
      { cost: 2500, price: 4000 },
      { cost: 2500, price: 4000 },
      { cost: 2500, price: 4000 },
      { cost: 2500, price: 4000 },
    ],
    meta: {},
  },
  {
    key: "backup",
    name: "Digital Documents Backup",
    description:
      "Will save digital copies of your documents so you can access them in app for a year",
    connected: [],
    process: [],
    processingTime: 5,
    price: [
      { cost: 0, price: 0 },
      { cost: 0, price: 500 },
      { cost: 0, price: 500 },
      { cost: 0, price: 500 },
      { cost: 0, price: 500 },
      { cost: 0, price: 500 },
      { cost: 0, price: 500 },
      { cost: 0, price: 500 },
      { cost: 0, price: 500 },
    ],
    meta: {},
  },

  // others,

  {
    key: "np",
    name:
      typeOfPlate === "regular"
        ? "Number Plate"
        : typeOfPlate === "regular-custom-lg"
          ? "Number Plate (Custom LG)"
          : "Number Plate (Customized)",
    description: "Required for during new registration for all vehicles",
    connected:
      typeOfDoc === "private"
        ? ["vl", "rw", "poc", "cmr", "vreg"]
        : ["vl", "hp", "rw", "poc", "cmr", "vreg"],
    process: [NEW_REG, CHANGE_OWNER],
    processingTime:
      typeOfPlate === "regular"
        ? 3
        : typeOfPlate === "regular-custom-lg"
          ? 7
          : 45,
    price:
      typeOfPlate === "regular"
        ? [
            { cost: 0, price: 0 },
            { cost: 50000, price: 54000 }, // + 4000
            { cost: 47000, price: 51000 },
            { cost: 47000, price: 51000 },
            { cost: 49000, price: 53000 },
            { cost: 60000, price: 64000 },
            { cost: 105000, price: 115000 }, // +10000
            { cost: 105000, price: 115000 },
            { cost: 105000, price: 115000 },
          ]
        : typeOfPlate === "regular-custom-lg"
          ? [
              { cost: 0, price: 0 },
              { cost: 50000, price: 74000 }, // + 4000 + 20000
              { cost: 50000, price: 71000 },
              { cost: 50000, price: 71000 },
              { cost: 50000, price: 73000 },
              { cost: 50000, price: 84000 },
              { cost: 105000, price: 135000 },
              { cost: 105000, price: 135000 },
              { cost: 105000, price: 135000 },
            ]
          : customizedNumberPlate,
    meta: {},
  },
  {
    key: "coc",
    name: "Change of Ownership Certificate",
    description:
      "Required during transfer of ownership of a registered vehicle",
    connected:
      typeOfDoc === "private"
        ? ["vl", "rw", "poc", "cmr", "vreg"]
        : ["vl", "hp", "rw", "poc", "cmr", "vreg"],
    process: [CHANGE_OWNER],
    processingTime: 21,
    price: [
      { cost: 0, price: 0 },
      { cost: 15000, price: 20000 }, // + 5000
      { cost: 15000, price: 20000 },
      { cost: 15000, price: 20000 },
      { cost: 16000, price: 21000 },
      { cost: 16000, price: 21000 },
      { cost: 25000, price: 30000 },
      { cost: 25000, price: 30000 },
      { cost: 25000, price: 30000 },
    ],
    meta: {},
  },
  {
    ...vehicleTrackingDocs,
  },
  {
    key: "processing",
    name: "Processing Fee",
    description:
      "Covers our fees for documents processing & handling with digital document backup that you can acess in app for a year",
    connected: [],
    process: [RENEWAL, ESTIMATE, CHANGE_OWNER, NEW_REG],
    processingTime: 1,
    price: [
      { cost: 0, price: 0 },
      { cost: 0, price: 2000 },
      { cost: 0, price: 2000 },
      { cost: 0, price: 2000 },
      { cost: 0, price: 2000 },
      { cost: 0, price: 2000 },
      { cost: 0, price: 2000 },
      { cost: 0, price: 2000 },
      { cost: 0, price: 2000 },
    ],
    meta: {
      disabled: true,
      // notDelivered: true,
      alwaysSelect: true,
    },
  },
]

module.exports = { docs }
